import { DEFAULT_VIEWING_MESSAGE } from "../../utils/propertyViewingEmailGenerator";

// Thomas's verified profile picture
export const SUNNY_IMAGE_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

export const PROPERTY_SIZES = ["1-bedroom", "2-bedroom", "3-bedroom", "4+ bedroom"];
export const CREW_SIZES = ["1 Crew Member", "2 Crew Members", "3 Crew Members", "4 Crew Members", "5+ Crew Members"];
export const VEHICLE_TYPES = ["No Van (Crew Only)", "Man & Van", "3.5 Tonne Truck", "7.5 Tonne Truck", "Luton Van", "Transit Van"];

export const CUSTOMER_STATUSES = [
  { value: "pending", label: "Pending", color: "bg-yellow-500" },
  { value: "scheduled", label: "Scheduled Call", color: "bg-blue-500" },
  { value: "deciding", label: "Deciding", color: "bg-purple-500" },
  { value: "booked", label: "Booked", color: "bg-green-500" },
  { value: "completed", label: "Completed", color: "bg-gray-500" },
];

export const PACKAGE_OPTIONS = [
  { value: "Loading Crew Only", label: "Loading Crew Only", description: "Crew only - No Van, Loading & unloading assistance, Hourly rate" },
  { value: "Man & Van", label: "Man & Van", description: "1 Driver + Van, Loading assistance, Perfect for small moves" },
  { value: "Economy Move", label: "Economy Move", description: "Loading & unloading, placing boxes" },
  { value: "Comfort Move", label: "Comfort Move", description: "Dismantling & reassembling furniture, Loading & unloading, Placing boxes in correct rooms" },
  { value: "Comfort Plus", label: "Comfort Plus - Full Packing", description: "Full packing of all items, Fragile packing included, Dismantling & reassembling, Loading & unloading, Items placed in correct rooms" },
  { value: "Premium - Pack, Move & Unpack", label: "Premium - Pack, Move & Unpack", description: "Full packing, Fragile packing, Dismantling & reassembling, Loading & unloading, Items placed in correct rooms, Full unpacking at destination" },
];

export const SENDER_EMAILS = [
  { value: "sales@homego-removals.com", label: "sales@homego-removals.com" },
  { value: "office@homego-removals.com", label: "office@homego-removals.com" },
];

export const DEFAULT_FORM_VALUES = {
  quotation_reference: "HG-00001",
  customer_name: "John Smith",
  property_size: "2-bedroom",
  moving_from: "MK11 4BB",
  moving_to: "MK14 7BB",
  moving_date: "Friday, 6 March 2026",
  crew_size: "2 Crew Members",
  vehicle_type: "3.5 Tonne Truck",
  deposit_amount: 95,
  additional_notes: "",
  economy_move_price: 385,
  comfort_move_price: 485,
  comfort_plus_price: 735,
  premium_price: 985,
  man_and_van_price: 285,
  loading_crew_price: 45,
  viewing_property_address: "",
  viewing_date: "",
  viewing_time: "",
  viewing_customer_mobile: "",
  viewing_magic_words: DEFAULT_VIEWING_MESSAGE,
  show_economy: true,
  show_comfort: true,
  show_comfort_plus: true,
  show_premium: true,
  show_man_and_van: true,
  show_loading_crew: true,
  arrival_time: "8:00 AM - 9:00 AM",
  selected_package: "Comfort Move",
  package_description: "Dismantling & reassembling furniture, Loading & unloading, Placing boxes in correct rooms",
  service_total: 485,
  special_notes: "",
  bank_account_name: "HOMEGO REMOVALS & PACKING LTD",
  bank_sort_code: "23-05-80",
  bank_account_number: "57158107",
  payment_link: "",
  // Invoice fields (shared between Confirmation and Deposit)
  invoice_service_name: "Comfort Move",
  invoice_service_description: "Dismantling & reassembling furniture, Loading & unloading, Placing boxes in correct rooms",
  invoice_customer_phone: "",
  invoice_customer_email: "",
  invoice_move_price: 485,
  invoice_deposit_amount: 100,
  // Deposit Received fields
  deposit_selected_package: "comfort",
  deposit_total_amount: "485",
  deposit_received_amount: "100",
  deposit_van_size: "Maxi Mover Van",
  deposit_crew_count: "2",
  deposit_moving_from_full: "123 High Street, London, E1 6AN",
  deposit_moving_to_full: "456 Oak Road, Manchester, M1 2AB",
  deposit_whats_next: "Our team will arrive between your scheduled time slot - please ensure someone is available to greet them\nHave all boxes sealed and items ready for loading to ensure a smooth start\nThe remaining balance of your move is due on the day - cash or bank transfer accepted\nLabel fragile items clearly so our team can handle them with extra care\nKeep essentials (documents, valuables, medications) with you separately\nContact us immediately if there are any last-minute changes to your move",
  deposit_our_commitment: "Your belongings will be handled with the utmost care and professionalism\nWe guarantee on-time arrival - if we're late, we'll make it right\nFully insured service with up to £50,000 goods in transit cover\nOur friendly, uniformed team will treat your home with respect\nNo hidden fees - the price we quote is the price you pay\nWe'll keep you informed throughout the entire moving process\nAll furniture will be wrapped and protected during transit",
  deposit_important_notes: "Please secure a parking spot for our van as close to your door as possible - this speeds up loading\nHave your keys ready and keep them with you at all times during the move\nIf you haven't received keys to your new property, contact your solicitor/estate agent BEFORE we arrive\nEnsure you have confirmed access time at your new address\nStay in contact with our office on 0330 043 4791 - we're here to help all day\nCheck all rooms, cupboards and the loft before we leave your old property\nTake meter readings at both properties for your records",
  deposit_payment_link: "",
  // Crew Recommendation fields
  booked_crew_count: "2",
  booked_van_type: "3.5T Van",
  recommended_crew_count: "3",
  recommended_van_type: "7.5T Truck",
  crew_upgrade_cost: "150",
  show_crew_recommendation: false,
  show_overtime_policy: false,
  overtime_rate: "120",
  work_hours_start: "9:00 AM",
  work_hours_end: "5:00 PM",
  // Pricing Calculator fields
  base_package_price: "485",
  extra_crew_count: "0",
  extra_van_count: "0",
  price_per_extra_crew: "150",
  price_per_extra_van: "150",
  // Multiple Locations
  pickup_location_1: "",
  pickup_location_2: "",
  pickup_location_3: "",
  dropoff_location_1: "",
  dropoff_location_2: "",
  dropoff_location_3: "",
  stop_location_1: "",
  stop_location_2: "",
  show_extra_pickups: false,
  show_extra_dropoffs: false,
  show_stops: false,
  // Special Requirements
  special_requirements: "",
  show_special_requirements: true,
  // Custom Message to Customer
  custom_recommendation_message: "",
  show_custom_message: true,
  // Why Choose Us fields
  why_headline: "Why Choose HomeGo Removals?",
  why_intro: "We understand that moving home is one of life's biggest moments. You need a team you can trust completely - one that treats your belongings like their own, arrives when promised, and makes your moving day completely stress-free.",
  why_promises: `We arrive on time, every time - or your money back
Your belongings are handled with care and fully insured
No hidden charges - the quote we give is the price you pay
Real-time updates so you always know what's happening
Dedicated support from start to finish`,
  // Service Packages
  why_economy_title: "Basic / Economy Move",
  why_economy_details: "Loading & unloading of your items into the van, careful transportation to your new address, placing boxes in your chosen rooms",
  why_economy_ideal: "Perfect for: Small moves, students, single items",
  why_comfort_title: "Comfort Move",
  why_comfort_details: "Everything in Economy PLUS dismantling & reassembling of beds and flat-pack furniture, wrapping of all furniture in protective blankets",
  why_comfort_ideal: "Perfect for: 1-2 bedroom homes, couples",
  why_complete_title: "Complete Comfort Move",
  why_complete_details: "Everything in Comfort PLUS full professional packing of ALL items, fragile items bubble-wrapped, wardrobe boxes for clothes",
  why_complete_ideal: "Families, 3+ bedroom homes",
  why_premium_title: "Premium Move",
  why_premium_details: "Everything in Complete Comfort PLUS full unpacking at destination, removal of all packing materials, furniture placement exactly where you want it",
  why_premium_ideal: "Luxury homes, busy professionals",
  // Consultant & Company Info
  consultant_name: "Thomas Jacobs",
  consultant_title: "Customer Consultant",
  consultant_image: SUNNY_IMAGE_URL,
  why_consultant_name: "Thomas Jacobs",
  why_consultant_title: "Customer Consultant",
  why_company_reg: "16811153",
  why_companies_house_link: "https://find-and-update.company-information.service.gov.uk/company/16811153",
  why_insurance_amount: "£50,000",
  why_video_upload_link: "https://homego-removals.com/upload",
  // Van Image Links
  why_luton_van_image: "https://homego-removals.com/images/luton-van.jpg",
  why_maxi_mover_image: "https://homego-removals.com/images/maxi-mover.jpg",
  why_ton_lorry_image: "https://homego-removals.com/images/7-5-ton-lorry.jpg",
  // Reviews (4 realistic reviews)
  why_review_1: "I was nervous about our move from London to Manchester with two kids and a lifetime of belongings. Thomas called me personally to go through everything. The team arrived at 8am sharp, worked non-stop, and had us unpacked by 6pm. Not a single scratch!",
  why_review_1_author: "Rachel Thompson",
  why_review_1_location: "London → Manchester",
  why_review_1_package: "Premium Move",
  why_review_2: "As a landlord with multiple properties, I've used dozens of removal companies. HomeGo is hands down the best - professional, efficient, transparent pricing. Thomas always responds within minutes. They're now my only choice.",
  why_review_2_author: "Mohammed Al-Rashid",
  why_review_2_location: "Birmingham",
  why_review_2_package: "Comfort Move",
  why_review_3: "Moving my elderly mum into her new bungalow was emotional. The HomeGo team were so patient and kind - they even helped her decide where to put her favourite armchair! Thomas checked in the next day. That level of care is rare.",
  why_review_3_author: "Linda Chen",
  why_review_3_location: "Bristol",
  why_review_3_package: "Complete Comfort",
  why_review_4: "Booked a last-minute office move when our lease fell through. HomeGo had a team available within 48 hours. Minimal downtime, everything labelled perfectly, IT equipment handled with extreme care.",
  why_review_4_author: "Patrick O'Sullivan",
  why_review_4_location: "Leeds",
  why_review_4_package: "Economy Move",
  // Review / Job Complete fields
  review_google_link: "",
  review_trustpilot_link: "",
  review_custom_message: "",
  // Affiliate Marketing fields
  affiliate_referral_amount: "100",
  affiliate_referral_code: "",
  affiliate_headline: "Earn £100 For Every Friend You Refer!",
  affiliate_intro: "Thank you for choosing HomeGo Removals! We hope your move went smoothly. As a valued customer, we'd love for you to share your experience with friends, family, and neighbours.",
  affiliate_how_it_works_1: "Share your unique referral code with friends, family or neighbours who need moving services",
  affiliate_how_it_works_2: "When they book with us and mention your code, they get £25 OFF their move",
  affiliate_how_it_works_3: "Once their move is complete, we'll send YOU £100 cash reward!",
  affiliate_share_message: "I just moved with HomeGo Removals and they were amazing! Use my code for £25 off your move:",
  affiliate_terms: "Referral must be a new customer. Reward paid within 7 days of completed move. No limit on referrals - refer as many people as you like!",
  affiliate_whatsapp_number: "",
  
  // Partnership fields
  partner_name: "Partner",
  partner_company: "Your Company",
  partner_type: "Storage",
  partner_area: "Milton Keynes",
  partner_director_name: "Allah Nazar Ihsan",
  partner_company_name: "HomeGo Removals & Packing Ltd",
  partner_company_email: "office@homego-removals.com",
  partner_company_website: "www.homego-removals.com",
  partner_commission: "100",
  partner_services: "House removals, office removals and Packing services",
  partner_insurance: "£50,000",
  partner_intro_message: "I hope you are well.",
  partner_closing_message: "We would love the opportunity to discuss this further and explore how we can collaborate effectively.",
  partner_show_attachments: true,
  partner_benefit_1: "£100 commission for every successful booking referral",
  partner_benefit_2: "Priority service for your referred customers",
  partner_benefit_3: "Dedicated account manager for your partnership",
  partner_benefit_4: "Co-branded marketing materials available",
  partner_benefit_5: "Monthly reporting on referral performance",
  // Message tab defaults
  message_customer_name: "",
  message_subject: "Message from HomeGo Removals",
  message_content: "",
  message_include_contact: true,
  message_template_id: "",
  consultant_name: "Thomas Jacobs",
  consultant_title: "Customer Consultant",
  consultant_email: "thomasjacobs@homego-removals.com",
};
